import template from './available_leave_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class LeaveAvailableHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class LeaveAvailableHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveAvailableHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'LeaveAvailableHelp',
	dialog_class: LeaveAvailableHelpPage,
	template: template,
	template_filename: 'translation/dialogs/available_leave_help',
	provider: 'ps'
};
